module.exports = __webpack_public_path__ + "img/chicken-outfit.2ad4a9e5.png";